// extracted by mini-css-extract-plugin
module.exports = {"pulseEffect":"VoIpHeader_pulseEffect__3wZJA","pulse":"VoIpHeader_pulse__3b2UU"};